import { IMarketPriceFilter } from '../../constants/filter/marketPriceFilter.constant';
import { priceSliderValueMapping } from '../../constants/filter/slider/filterSliderConstant';

interface ICreateMarketPriceFilterSearchParamsParam {
  filters: IMarketPriceFilter[];
}

interface ICreateMarketPriceFilterSearchParamsReturn {
  brand?: string;
  minEngineOutputPs: number;
  maxEngineOutputPs: number;
  minMedianPrice: number;
  maxMedianPrice: number;
  sort: string;
  count: number;
  page: number;
}

export const createMarketPriceFilterSearchParams = ({
  filters,
}: ICreateMarketPriceFilterSearchParamsParam): ICreateMarketPriceFilterSearchParamsReturn => {
  const getFilterOptionValues = (filterKey: string) =>
    filters
      .find((filter) => filter.key === filterKey)
      ?.options.filter((option) => option.isSelected)
      .map((option) => option.value)
      .join(',');

  const sorterFilterOptionValues = getFilterOptionValues('sorter');
  const brandFilterOptionValues = getFilterOptionValues('filter_brand');
  const engineOutputPsFilterOptionValues = getFilterOptionValues('engineOutputInPs');
  const medianPriceFilterOptionValues = getFilterOptionValues('medianPrice');

  const engineOutputPsMin = Number(engineOutputPsFilterOptionValues?.split(',')[0]);
  const engineOutputPsMax = Number(engineOutputPsFilterOptionValues?.split(',')[1]);

  const medianPriceMin = Number(medianPriceFilterOptionValues?.split(',')[0]);
  const medianPriceMax = Number(medianPriceFilterOptionValues?.split(',')[1]);

  return {
    brand: brandFilterOptionValues ?? undefined,
    minEngineOutputPs: engineOutputPsMin ?? 0,
    maxEngineOutputPs: engineOutputPsMax ?? 0,
    minMedianPrice: priceSliderValueMapping[medianPriceMin] ?? 0,
    maxMedianPrice: priceSliderValueMapping[medianPriceMax] ?? 0,
    sort: sorterFilterOptionValues ?? 'medianPrice_desc',
    count: 10,
    page: 1,
  };
};
